import './accordion.scss';
import $ from 'jquery';

$(document).ready(function () {
  $('.accordion-section').each(function () {
    var self = {
      elem: null,
      init: function (elem) {
        self.elem = elem;
        // self.accordionShow()
        self.initClickListeners();
      },
      initClickListeners: function () {
        self.elem.find('.collapse').on('show.bs.collapse', function () {
          self.elem.addClass('accordion-active');
        });
        self.elem.find('.collapse').on('hide.bs.collapse', function () {
          self.elem.removeClass('accordion-active');
        });
      }
    };
    var elem = $(this);
    self.init(elem);
  });
});



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js